<template>
  <yxt-card
    class="gwnl-card"
    shadow="never"
  >
    <div
      v-if="showHeader"
      slot="header"
      class="clearfix standard-size-16 font-medium align-items-center"
    >
      <yxt-svg
        :remote-url="gwnlMediaDomain + 'svg/certifications'"
        width="28px"
        height="28px"
        icon-class="preview-skills"
        class="mr8"
      />
      <span>{{ $t('pc_gwnl_model_template__info_skill_title') }}</span>
    </div>
    <div v-if="list.length === 0">
      <yxt-empty />
    </div>
    <div
      v-else
      class="clearfix"
    >
      <yxtbiz-skill-viewer
        :list="list"
        v-bind="$attrs"
      />
    </div>
  </yxt-card>
</template>

<script>
import { GWNL_MEDIA_DOMAIN } from './domain';

export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      gwnlMediaDomain: GWNL_MEDIA_DOMAIN
    };
  }
};
</script>
<style lang="scss" scoped>
.gwnl-card.yxt-card {
  flex: 1 1 auto;
  margin-bottom: 12px;
}

.chartName {
  font-size: 16px;
  line-height: 24px;
}

.table-fix-style {
  ::v-deep [class*='yxt-table__row--levyxt'] .yxt-table__expand-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 3px;
    line-height: 20px;
    text-align: center;
  }
}

.gwnl-jq-create-skills-header-index {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 16px;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  border-radius: 3px;
}

.color-BF {
  color: #bfbfbf;
}
</style>
